import { LoadStatus, PageCollapsibleBlock, PortalUrls } from '@servicetitan/cp-ui';
import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import { DashboardInvoicesStore } from '../../stores/dashboard-invoices.store';
import { InvoicesSettingsFiltersStore } from '../../stores/invoices-settings-filters.store';
import { InvoicesList } from './invoices-list/invoices-list';

interface DashboardInvoicesProps {
    filtered: boolean;
    className?: string;
    resetFilters(): void;
}

export const DashboardInvoices: FC<DashboardInvoicesProps> = observer(props => {
    const { className, filtered, resetFilters } = props;

    const [invoicesSettingsFiltersStore, dashboardInvoicesStore] = useDependencies(
        InvoicesSettingsFiltersStore,
        DashboardInvoicesStore
    );

    useEffect(() => {
        const loadData = async () => {
            const settingsFilterFlags = await invoicesSettingsFiltersStore.init();
            if (settingsFilterFlags !== null) {
                dashboardInvoicesStore.loadInvoices();
            }
        };
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const allInvoicesHref = PortalUrls.invoices.root;
    const loading = dashboardInvoicesStore.loadStatus === LoadStatus.Loading;

    return (
        <PageCollapsibleBlock
            icon="st_invoice"
            title="Unpaid Invoices"
            count={dashboardInvoicesStore.invoiceData?.totalCount ?? 0}
            allRecordsHref={allInvoicesHref}
            loading={loading}
            className={className}
            data-tracking-component="portal-dashboard-unpaid-invoices"
            data-cy="dashboard-unpaid-invoices"
        >
            <InvoicesList
                filtered={filtered}
                invoices={dashboardInvoicesStore.invoiceData?.invoices}
                resetFilters={resetFilters}
            />
        </PageCollapsibleBlock>
    );
});
